import theme from "theme";
// @NOTE - cannot use styled-component due to the typing of react-phone-input-2 inputStyle prop
export const phoneNumberStyle = {
  borderRadius: "3px",
  border: `1px solid ${theme.colors.grey_4}`,
  backgroundColor: "#ffffff",
  //height: "33px",
  width: "85%",
};
